import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalculator, FaRuler, FaChartLine, FaCode, FaFileCode, FaClock, FaExchangeAlt, FaImage } from 'react-icons/fa';

const Home: React.FC = () => {
  const utilities = [
    {
      id: 'calculator',
      name: 'Calculator',
      path: '/math/calculator',
      description: 'A simple calculator for basic arithmetic operations',
      //@ts-ignore
      icon: <FaCalculator className="w-8 h-8" />,
    },
    {
      id: 'converter',
      name: 'Converter',
      path: '/math/converter',
      description: 'Convert between different units of measurement',
      //@ts-ignore
      icon: <FaRuler className="w-8 h-8" />,
    },
    {
      id: 'graph',
      name: 'Graph Plotter',
      path: '/math/graph',
      description: 'Plot mathematical functions and equations',
      //@ts-ignore
      icon: <FaChartLine className="w-8 h-8" />,
    },
    {
      id: 'time',
      name: 'Time Utility',
      path: '/time',
      description: 'Convert time zones, calculate time differences, and view world time map',
      //@ts-ignore
      icon: <FaClock className="w-8 h-8" />,
    },
    {
      id: 'encoders',
      name: 'Encoders/Decoders',
      path: '/text/encoders',
      description: 'Encode and decode text in various formats',
      //@ts-ignore
      icon: <FaCode className="w-8 h-8" />,
    },
    {
      id: 'json',
      name: 'JSON Utility',
      path: '/text/json',
      description: 'Format, validate, and transform JSON data',
      //@ts-ignore
      icon: <FaFileCode className="w-8 h-8" />,
    },
    {
      id: 'diff',
      name: 'Text Diff Checker',
      path: '/text/diff',
      description: 'Compare two texts and highlight the differences',
      //@ts-ignore
      icon: <FaExchangeAlt className="w-8 h-8" />,
    },
    {
      id: 'image',
      name: 'Image Processor',
      path: '/art/image',
      description: 'Crop, resize, compress, and convert images in your browser.',
      //@ts-ignore
      icon: <FaImage className="w-8 h-8" />,
    },
  ];

  return (
    <div className="max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Welcome to Davinqi</h1>
        <p className="text-xl text-gray-600 dark:text-gray-300">Your all-in-one utility hub</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {utilities.map((utility) => (
          <Link
            key={utility.id}
            to={utility.path}
            className="block p-6 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 transition-colors"
          >
            <div className="flex items-center mb-4">
              <div className="text-primary mr-4">{utility.icon}</div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{utility.name}</h2>
            </div>
            <p className="text-gray-600 dark:text-gray-300">{utility.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Home; 